"use strict";

import BetragsrechnerBase from "../betragsrechner.base";

class BildungkostenRechner extends BetragsrechnerBase {
  /*@ngInject*/
  constructor($scope, kontext) {
    super($scope, kontext);
    this.name = "bildungskostenrechner";
    this.component_name = "bildungkosten";
    this.labels = { anzahl_tage: "Veranstaltungstage",
                    anzahl_personen: "Personenanzahl (Teilnehmer, Referenten und Betreuer)" };
  }

  get_labelmapping() {
    return this.labels;
  }

  get_fields(params) {
    return { anzahl_tage: "",
             anzahl_personen: "",
             tagespauschale: params.tagespauschale,
    };
  }
}
export default BildungkostenRechner;
